import { Product, ProductSummary } from 'types/product';
import { PagedResult } from 'types/api';

/** Shape típico de producto en Store API (camelCase). */
export type StoreProductApiItem = {
  id?: string;
  slug?: string;
  sku?: string;
  name?: string;
  description?: string;
  price?: number;
  currency?: string;
  imageUrl?: string;
  imageUrls?: string[];
  brandName?: string;
  categoryName?: string;
  categorySlug?: string;
  stock?: number;
  availableQty?: number;
  inStock?: boolean;
  isOnPromotion?: boolean;
  isNew?: boolean;
};

export const mapStoreProduct = (item: StoreProductApiItem): ProductSummary => {
  const sku = (item.sku || item.id || '').trim();
  const slug = (item.slug || sku || item.id || '').trim();
  return {
    id: sku || slug,
    slug: slug || sku,
    name: item.name || sku || slug,
    description: item.description,
    sku: sku || undefined,
    price: Number(item.price ?? 0),
    currency: item.currency,
    imageUrl: item.imageUrl || item.imageUrls?.[0],
    brandName: item.brandName,
    isOnPromotion: item.isOnPromotion,
    isNew: item.isNew,
  };
};

export const mapStoreProductDetail = (item: StoreProductApiItem): Product => ({
  ...mapStoreProduct(item),
  stock: item.stock ?? (item.availableQty != null ? Number(item.availableQty) : undefined),
  categoryName: item.categoryName,
  categorySlug: item.categorySlug,
  imageUrls: item.imageUrls,
  images: item.imageUrls,
});

export const asProductList = (data: unknown): StoreProductApiItem[] => {
  if (Array.isArray(data)) return data;
  if (data && typeof data === 'object' && Array.isArray((data as PagedResult<StoreProductApiItem>).items)) {
    return (data as PagedResult<StoreProductApiItem>).items;
  }
  return [];
};
